import * as yup from 'yup'
import { VALIDATION } from 'utils/globalConstant'

export const validationSchema = yup.object({
  pay_grade_name: yup.string().required(VALIDATION.required).max(150, VALIDATION.max),
  basic_salary: yup.string().required(VALIDATION.required),
  gross_salary: yup.string().required(VALIDATION.required),
})
